<template>
  <b-navbar v-if="isReady" toggleable="xl" type="light" class="bg-secondary p-3">
    <div class="container-fluid">
      <landing-logo size="40px" />

      <b-navbar-toggle
        target="nav-primary"
        class="navbar-toggler is-active collapsed hamburger hamburger--elastic"
      >
        <span class="hamburger-box">
          <span class="hamburger-inner" />
        </span>
      </b-navbar-toggle>

      <b-collapse id="nav-primary" is-nav>
        <ul
          class="navbar-nav ml-lg-auto mt-lg-0 mt-3 px-lg-0 px-3 py-3 py-md-0 d-flex align-items-center"
        >
          <li class="nav-item" @click="refetchLearningUnits">
            <router-link
              v-if="!user || (user && !user.isRole('reviewer'))"
              class="nav-link mx-lg-3"
              :to="{ name: 'learning-unit' }"
            >
              Explore
            </router-link>
          </li>

          <!-- <li
            v-if="user && !user.isRole('reviewer')"
            class="nav-item"
          >
            <router-link
              class="nav-link mx-lg-3"
              :to="{ name: 'learning-unit/my-learning-unit' }"
            >
              My Learning Units
            </router-link>
          </li> -->

          <li v-if="user && !user.isRole('reviewer')" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'user-dashboard' }">
              User Dashboard
            </router-link>
          </li>

          <li v-if="user && !user.isRole('reviewer')" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'badge-collection' }">
              Badge Collection
            </router-link>
          </li>

          <!-- <li
            v-if="user && user.isRole('learner') && !user.isRole('teacher')"
            class="nav-item"
          >
            <a
              class="nav-link mx-lg-3"
              href="https://etskmutt.typeform.com/to/qxSlIlhD?typeform-source=www.google.com#file=xxxxx"
              target="_blank"
            >
              Become an Instructor
            </a>
          </li> -->

          <li v-if="user && user.isRole('issuer')" class="nav-item">
            <a class="nav-link mx-lg-3" :href="catalogGrantPage">Grant Badge</a>
          </li>

          <li v-if="user && user.isRole('reviewer')" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'review-learning-unit' }">
              Review Submitted Micro-Credentials
            </router-link>
          </li>

          <li v-if="user && user.isRole('reviewer')" class="nav-item">
            <a
              class="nav-link mx-lg-3"
              :href="catalogStackPage"
              target="_blank"
              rel="noopener noreferrer"
            >
              Stack Managing
            </a>
          </li>

          <li v-if="user && user.isRole('designer')" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'design-planning' }">
              Design and planning
            </router-link>
          </li>

          <!-- <li v-if="user && user.isRole('teacher')" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'teaching' }">
              Teaching
            </router-link>
          </li> -->

          <li v-if="user && (user.isAssessor() || user.isOwner())" class="nav-item">
            <router-link class="nav-link mx-lg-3" :to="{ name: 'evaluate' }">
              Evaluate
            </router-link>
          </li>

          <li v-if="!user || (user && !user.isRole('reviewer'))" class="nav-item">
            <a
              class="nav-link mx-lg-3"
              href="https://support.4lifelonglearning.org/hc/th"
              target="_blank"
            >
              Support
            </a>
          </li>

          <!-- <li v-if="user && user.is_old_user" class="nav-item">
            <a class="nav-link mx-lg-3" :href="oldSiteEndpoint">
              Go to 4Life Site
            </a>
          </li> -->

          <!-- <li
            v-if="user && !user.isRole('reviewer')"
            class="nav-item span__navbar-all-message"
          >
            <BaseChatMessageIcon />
          </li> -->

          <li v-if="!user" class="nav-item" @click="login()">
            <a class="nav-link mx-lg-3" href="javascript:void(0);">Sign in</a>
          </li>

          <li v-if="!user" class="nav-item">
            <b-button variant="first" @click="goToSignUpPage">
              <span>Sign up</span>
            </b-button>
          </li>

          <li
            v-if="
              user &&
              !user.isRole('reviewer') &&
              !user.isRole('issuer') &&
              $_isFeatureEnabled('Cart')
            "
            class="nav-item"
          >
            <router-link :to="{ name: 'cart-item' }">
              <cart-navbar-item :user-id="userId" />
            </router-link>
          </li>

          <div v-if="user" class="nav-item ml-lg-3">
            <BaseUserProfile
              :user-name="user.name"
              :picture="user.profile_picture"
              @onClickProfile="goToProfilePage"
            >
              <template slot="name">
                <b-nav-item-dropdown right>
                  <template slot="button-content">
                    <span class="mr-1">{{ user.name }}</span>
                  </template>
                  <b-dropdown-item href="javascript:void(0)" @click="goToProfilePage">
                    My Profile
                  </b-dropdown-item>
                  <div
                    v-if="
                      user &&
                      !user.isRole('reviewer') &&
                      !user.isRole('issuer') &&
                      $_isFeatureEnabled('purchase_buynow')
                    "
                  >
                    <b-dropdown-item
                      href="javascript:void(0)"
                      class="button-dropdown-my_purchase"
                      @click="goToPurchasePage"
                    >
                      My Purchase
                    </b-dropdown-item>
                  </div>

                  <b-dropdown-divider />
                  <b-dropdown-item href="javascript:void(0)" @click="onLogOut">
                    <b-spinner
                      v-if="isLoggingOut"
                      label="Logging out..."
                      variant="dark"
                      style="width: 1.25rem; height: 1.25rem"
                    />

                    <span v-if="isLoggingOut">Logging Out...</span>

                    <span v-else>Logout</span>
                  </b-dropdown-item>
                </b-nav-item-dropdown>
              </template>
            </BaseUserProfile>
          </div>
        </ul>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
/* Trigger event cross component */
import { eventBus } from '../../main';

/* Node Package */
// import { map } from "lodash";

/* Mixins */
import { channelMixin } from '@/mixins/channelMixin';
import { userInfoMixin } from '@/mixins/userInfoMixin';
import { zendeskMixin } from '@/mixins/zendeskMixin';
import { optimizelyMixin } from '@/mixins/optimizelyMixin';

/* Models */
// import User from "@/models/User";
// import UserEnrollment from "@/models/UserEnrollment";

// import { getAuth, signOut } from "firebase/auth";

import {
  BaseUserProfile
  // BaseChatMessageIcon,
} from '@/components/base-components';
import LandingLogo from './LandingLogo.vue';
import { useAuth } from '../../composables';
import { Auth } from '../../models/Auth';
import CartNavbarItem from '@/components/Cart/CartNavbarItem.vue';

const { logout } = useAuth();

export default {
  name: 'Navbar',

  components: {
    BaseUserProfile,
    LandingLogo,
    CartNavbarItem
    // BaseChatMessageIcon
  },

  mixins: [channelMixin, userInfoMixin, zendeskMixin, optimizelyMixin],

  data() {
    return {
      isLoggingOut: false
    };
  },

  computed: {
    pageType() {
      return this.$route.name;
    },

    catalogStackPage() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      return `${baseUrl}/ets-4life/stacks`;
    },

    catalogGrantPage() {
      const baseUrl = process.env.VUE_APP_CATALOG_APP_URL;

      return `${baseUrl}/grant`;
    },

    isReady() {
      return Auth.isInitialized();
    }
  },

  async created() {
    // if (this.$cookies.isKey("user-learn4life")) {
    //   const userInfo = this.$cookies.get("user-learn4life");
    //   const { uid, jwt_token } = userInfo;
    //   this.user_id = uid;
    //   let sections;
    //   let user_enrollments;
    //   const responseFetchUserByUid = await User.api().fetchByUid(uid);
    //   const user_roles = responseFetchUserByUid.response.data[0].user_roles.map(
    //     (user_role) => user_role.role
    //   );
    //   let { response } = await UserEnrollment.api().fetchByParams({ uid: uid });
    //   if (response && response.data) {
    //     user_enrollments = response.data;
    //     sections = map(response.data, "section");
    //   }
    //   const { id, firstname, lastname, description, email, learning_units } =
    //     responseFetchUserByUid.response.data[0];
    //   User.insert({
    //     data: {
    //       id,
    //       firstname,
    //       lastname,
    //       roles: user_roles,
    //       uid,
    //       jwt_token,
    //       email,
    //       description,
    //       sections,
    //       user_enrollments,
    //       learning_units,
    //     },
    //   });
    // }
    // this.login();
  },

  methods: {
    refetchLearningUnits() {
      eventBus.$emit('resetLearningUnits');
    },

    login() {
      if (this.pageType === 'SignIn') return;

      this.$router.push({
        name: 'SignIn',
        query: {
          previousPath: this.$route.fullPath
        }
      });
    },

    goToSignUpPage() {
      if (this.pageType === 'SignUp') return;

      this.$router.push({ name: 'SignUp' });
    },

    goToProfilePage() {
      if (this.pageType === 'Profile') return;

      this.$router.push({ name: 'profile' });
    },

    goToPurchasePage() {
      if (this.pageType === 'Purchase') return;

      this.$router.push({ name: 'purchase' });
    },

    async onLogOut() {
      this.isLoggingOut = true;

      await logout();

      this.isLoggingOut = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.cursur-pointer {
  cursor: pointer;
}

.nav__icon-frame {
  width: 44px;
  height: 44px;
  border-radius: 10.4px;
}

.btn-notification {
  background-color: #e5f9ed;
  text-decoration: none;
  position: relative;
  border-radius: 12px;
  padding: 5px 10px !important;
  cursor: pointer;
}

.badge-notification {
  background-color: #ff838f;
  position: absolute;
  top: -4px;
  right: -7px;
  padding: 0 5px;
  margin: 1px;
  border-radius: 50%;
  color: white;
  font-size: 10px;
}
</style>
